<main [@fadeInOut] id="main-heading" role="main" tabindex="0" [class]="isFeatureFlagVisible ? 'd-block' : 'd-none' ">
    <div class="container-fluid padding-bottom-small bottom-padding">
      <div class="col-sm-11 center-block">
        <div *ngIf="hasIngestPermission">
          <h1 tabindex="0" aria-label="SPL Upload" role="heading" aria-level="1">SPL Upload</h1>
          <div class="file-upload col-md-12">
            <app-file-upload [iconClassName]="'fa-file-zip'"
                              [formatDisplayText]="'Zip (.zip) format only'"
                              [allowExtensions]="'.zip'"
                              [multipleFileMode]="true"
                              [maxDropAreaHeight]="500"
                              [sequentialUpload]="true"
                              [autoUploadEnabled]="true"
                              [saveUrl]="uploadSaveUrl"
                              (uploading)="onFileUploadStart($event)"
                              (success)="onFileUploadedSuccess($event)"
                              (failure)="onUploadFailure($event)">
            </app-file-upload>
          </div>
        </div>
      <div class="mt-3">
        <app-fileuploadhistorygrid #fileuploadhistorygrid></app-fileuploadhistorygrid>
      </div>
    </div>

    <div *ngIf="loading" class="backdrop">
        <div id="loading"></div>
    </div>

    </div>

</main>
